import React, { Component, Fragment } from "react";
import _ from "lodash";
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
import BootstrapTable2 from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import EditorTevekenyseg from './EditorTevekenyseg';
import Loader from "../../../commons/loader";
import paginationFactory from "react-bootstrap-table2-paginator";
import Service from "../services";
import { PaginationTotal, ImageCard } from "../../../commons/controls";
import DataEmptyState from "../../../commons/dataemptystate";
import NetworkEmptyState from "../../../commons/networkemptystate";
import ReactHtmlParser from "react-html-parser";
import DropZone from "react-dropzone";
import RFField from "../../../components/Form/RFField";
import RFForm from "../../../components/Form/RFForm";
import { parseEditorImage } from "../../../commons/utils";
import Lib from "../../../commons/lib";

const renderLeirasEditor = (onChange, value, fontId) => {
  const editor =  <EditorTevekenyseg
  onChange={onChange}
  field={value}
  fontId={fontId}
  // listImages={this.listImages}
  // addImage={this.addImage}
/>
  return editor;
}

class TevekenysegContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      angolNyelv: false,
      enums: [],
      kozpontienums: [],
      helyszin: {},
      helyszinek: [],
      helyszinid: "",
      esettipusok: [],
      esettipusid: "",
      leiras: '',
      leirasAngol: '',
      modalPartner: false,
      modalPartnerModosit: false,
      modalPartnerTorles: false,
      modalNezet: false,
      modalTevekenyseg: false,
      editorsOpen: false,
      modalTevekenysegModosit: false,
      modalTevekenysegTorles: false,
      formType: "FEL",
      partner: {},
      partnerek: [],
      partnerAdatok: [],
      partnerid: {},
      objects: [],
      partnerJson: [],
      tevekenyseg: [],
      tevekenysegJson: null,
      tevekenysegAdd: [],
      tevekenysegModosit: [],
      tipus: "",
      currentId: null,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDE(EN)']
      tableStatus: "HIDE",
      helyszinOptions: [],
      deletedImages: [],
    };
    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "25", value: 25 }
      ]
    };

    this.onChangeLeiras = this.onChangeLeiras.bind(this);
    this.onChangeLeirasAngol = this.onChangeLeirasAngol.bind(this);
    this.listImages = this.listImages.bind(this);
    this.addImage = this.addImage.bind(this);
  }

  // editorAnyad = (onChange, field, fontId) => {
  //   return (
  //     <EditorTevekenyseg
  //       onChange={({ value }) => {onChange({ value })}}
  //       field={field}
  //       fontId={fontId}
  //       // listImages={this.listImages}
  //       // addImage={this.addImage}
  //     />
  //   );
  // }

  componentDidMount() {
    this.getHelyszinek();
    this.getEsetTipusok();
    this.getEnums();
    this.renderTevekenysegTipusOptions();
    this.checkAngolNyelv();
  }

  checkAngolNyelv = () => {
    Service.getAngolNyelv((err, res) => {
      if (!err) {
        this.setState({ angolNyelv: res[0] });
      }
    });
  }

  handleTevekenysegEditClick = (id) => {
    this._currentId = id;
    this.setState({ formType: "MOD", currentId: id });
    Service.getTevekenyseg(id, (err, res) => {
      if (!err) {
        this.setState({
          partnerAdatok: res[0],
          objects: []
        });

        res[0].map((element) => {
          if (element.tipus.name === "PAR") {
            this.setState({
              tipus: element.tipus,
              objects: element.objects
            });
          } else {
            if (element.leiras) {
              this.setState({
                tevekenysegid: element.id,
                helyszinid: element.helyszinid,
                tipus: element.tipus,
                esettipusid: element.esetTipusId,
                leiras: element.leiras
              });
            }
            if (this.state.angolNyelv == true) {
              if (element.leirasangol) {
                this.setState({
                  leirasAngol: element.leirasangol
                });
              } else {
                this.setState({ leirasAngol: '' });
              }
            }
          }
        });
        this.toggleTevekenyseg();
      }
    });
  };

  renderFormTitle = () => {
    if (this.state.formType === "FEL") {
      return "Tevékenység felvétele";
    }
    if (this.state.formType === "MOD") {
      return "Tevékenység módosítása";
    }
  };

  handleTevekenysegDeleteClick = id => {
    this._currentId = id;
    this.toggleTevekenysegTorles();
    this.setState({ partnerAdatok: [] });
  };

  handleViewClick = id => {
    Service.getTevekenyseg(id, (err, res) => { 
      if (!err) {
        this.setState({
          partnerAdatok: res[0]
        });
        res[0] && res[0].map((element) => {
          if (element.tipus.name !== "PAR") {
            this.setState({
              tevekenysegid: element.id,
              helyszinid: element.helyszinid,
              tipus: element.tipus,
              leiras: element.leiras,
              esettipusnev: element.esettipusnev
            });
            if (this.state.angolNyelv == true) {

              this.setState({ leirasAngol: element.leirasangol });
            }
          }
          if (element.tipus.name === "PAR") {
            this.setState({
              tipus: element.tipus
            });
          }
        });
        this.toggleNezet();
      }
    });
  };

  handlePartnerNevChange = (e, idx) => {
    let newState = this.state.partnerAdatok;
    if (newState[0].length > 1) {
      newState[0][idx].partnerNeve = e.target.value;
    } else {
      newState[idx].partnerNeve = e.target.value;
    }
    this.setState({ partnerAdatok: newState });
  };

  handlePartnerLogoChange = (e, idx) => {
    let newState = this.state.partnerAdatok;
    newState[idx].objects = this.state.objects;
    this.setState({ partnerAdatok: newState, objects: [] });
  };

  handleLeirasChange = (e, idx) => {
    let newState = this.state.partnerAdatok;
    if (newState[0].length > 1) {
      newState[0][idx].leiras = e.target.value;
    } else {
      newState[idx].leiras = e.target.value;
    }
    this.setState({ partnerAdatok: newState });
  };

  handleLeirasAngolChange = (e, idx) => {
    let newState = this.state.partnerAdatok;
    if (newState[0].length > 1) {
      newState[0][idx].leirasangol = e.target.value;
    } else {
      newState[idx].leirasangol = e.target.value;
    }
    this.setState({ partnerAdatok: newState });
  };

  deletePartneradat = idx => {
    let newState = this.state.partnerAdatok;
    newState.splice(idx, 1);
    this.setState({ partnerAdatok: newState });
  };

  addPartnerAdatRow = () => {
    let newPartneradat = this.state.partnerAdatok;
    let object = {
      helyszinid: this.state.helyszinid,
      tipus: "PAR",
      partnerNeve: "",
      objects: [],
      leiras: ""
    };

    if (this.state.angolNyelv == true) {
      object = { ...object, leirasangol: "" };
    }

    newPartneradat.push(object);
    this.setState({ partnerAdatok: newPartneradat });
  };

  renderPartnerList = () => {
    let adatok = [];
    this.state.partnerAdatok.forEach((item, idx) => {
      adatok.push(
        <Fragment key={idx.toString()}>
          <RFField
            label="Partner neve:"
            name={"partnernev" + idx}
            onChange={e => this.handlePartnerNevChange(e, idx)}
            value={item.partnerNeve || this.state.partnernev}
          />
          <>
            <Label>Partner logo:</Label>
            {this.state.objects.length < 2 ? (
              <DropZone
                onDrop={e => this.onDropLogo(e, idx)}
                className="custom-dropzone"
                style={{ height: "50px" }}
                onBlur={e => {
                  this.handlePartnerLogoChange(e, idx);
                }}
                multiple={false}
              >
                {({getRootProps, getInputProps}) => (
                  <div {...getRootProps({ className: 'custom-dropzone'})}>
                    <input {...getInputProps()} />
                    <div className="dropzone-text">
                      {'Kép feltöltése!'}
                    </div>
                  </div>
                )}
              </DropZone>
            ) : (
                ""
              )}
          </>

          <div>
            {item.objects !== null
              ? item.objects.map((logo, logoIdx) => {
                return (
                  <div className="col-md-3" key={logoIdx.toString()}>
                    <ImageCard
                      poster
                      style={{ maxWidth: "200px" }}
                      key={logoIdx.toString()}
                      mime={logo.mime}
                      title={logo.docname}
                      content={logo.content}
                      src={logo.src}
                      onDeleteClick={e => {
                        let partnerAdatok = JSON.parse(
                          JSON.stringify(this.state.partnerAdatok)
                        );
                        partnerAdatok[idx].objects = [];
                        this.setState({
                          partnerAdatok: partnerAdatok
                        });
                      }}
                    />
                  </div>
                );
              })
              : ""}
          </div>
          <RFField
            label="Leírás:"
            type="textarea"
            name={"leiras" + idx}
            onChange={e => this.handleLeirasChange(e, idx)}
            value={item.leiras}
          />
          {this.state.angolNyelv == true ?
            <RFField
              label="Leírás (angol):"
              type="textarea"
              name={"leirasangol" + idx}
              onChange={e => this.handleLeirasAngolChange(e, idx)}
              value={item.leirasangol}
            />
            : <div />
          }

          <div>
            <Button
              color="danger"
              style={{ marginTop: "29px" }}
              type="button"
              onClick={() => this.deletePartneradat(idx)}
            >
              Törlés
            </Button>{" "}
          </div>
          <br />
        </Fragment>
      );
    });

    return adatok;
  };

  iconFormatter = cell => {
    return (
      <div>
        <Button
          className="icon-eye table-action-icon"
          id={"action-view-" + cell + "megtekintes"}
          onClick={() => this.handleViewClick(cell)}
          onMouseDown={e => {
            if (e) {
              e.preventDefault();
            }
          }}
        />
        <Button
          className="icon-pencil table-action-icon"
          id={"action-view-" + cell + "modositas"}
          onClick={() => this.handleTevekenysegEditClick(cell)}
          onMouseDown={e => {
            if (e) {
              e.preventDefault();
            }
          }}
        />
        <Button
          className="icon-trash table-action-icon"
          id={"action-view-" + cell + "torles"}
          onClick={() => this.handleTevekenysegDeleteClick(cell)}
          onMouseDown={e => {
            if (e) {
              e.preventDefault();
            }
          }}
        />
        <UncontrolledTooltip trigger='hover focus-visible'
          style={{ float: "left" }}
          placement="top"
          target={"action-view-" + cell + "megtekintes"}
          delay={0}
        >
          Megtekintés
        </UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible'
          style={{ float: "left" }}
          placement="top"
          target={"action-view-" + cell + "modositas"}
          delay={0}
        >
          Módosítás
        </UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible'
          style={{ float: "left" }}
          placement="top"
          target={"action-view-" + cell + "torles"}
          delay={0}
        >
          Törlés
        </UncontrolledTooltip>
      </div>
    );
  };

  getHelyszinek = () => {
    Service.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach(e => options.push(<option key={e.id} value={e.id}>{e.nev}</option>));

        this.setState({
          helyszinek: res[0],
          helyszinOptions: options,
          helyszinid: res[0].length === 1 ? res[0][0].id : '',
          helyszin: res[0].length === 1 ? res[0][0] : {}
        });

        if (res[0].length === 1) {
          this.updateTable();
        }
      }
    });
  };

  getEsetTipusok = () => {
    Service.listEsetTipus((err, res) => {
      if (!err) {
        this.setState({ esettipusok: res[0] });
      }
    });
  };

  getEnums = () => {
    Service.listTevekenysegEnums((err, res) => {
      if (!err) {
        this.setState({
          kozpontienums: res[0].filter(item => item.kozponti == null || item.kozponti === true),
          enums: res[0].filter(item => item.kozponti == null || item.kozponti === false)
        });
      }
    });
  };

  helyszinValaszto = () => {
    return (
      <RFForm onSubmit={() => {}}>
        <RFField
          type="select"
          name="formHelyszin"
          label="Helyszín neve:"
          value={this.state.helyszinid}
          onChange={this.handleHelyszinSelectChange}
          defaultSelect={<option value="">Válassz helyszínt...</option>}
          selectOptions={this.state.helyszinOptions}
        />
      </RFForm>
    );
  };

  handleHelyszinSelectChange = e => {
    const { target } = e;
    const value = target.value;
    if (value === "") {
      this.setState({
        helyszinid: "",
        tableStatus: "HIDE",
        tevekenysegJson: []
      });
    } else {
      this.setState(
        prevState => ({
          helyszinid: value,
          helyszin: prevState.helyszinek.find(helyszin => {
            return helyszin.id == value;
          })
        }),
        () => {
          if (value !== "") this.updateTable();
          else this.setState({ tevekenysegJson: [], tableStatus: "HIDE" });
        }
      );
    }
  };

  handleTevekenysegTipusSelectChange = e => {
    const { target } = e;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({
      tipus: value
    });
  };

  handleInputChange = e => {
    const { target } = e;
    const { name } = target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({
      [name]: value
    });
  };

  getTevekenysegList = () => {
    this.setState(
      {
        tableStatus: "LOAD"
      },
      () => {
        Service.listTevekenyseg(this.state.helyszinid, (err, res) => {
          if (!err) {
            res[0].map(element => {
              element.tipusnev = element.tipus.caption;
            });
            this.setState({
              tevekenysegJson: res[0],
              tableStatus: res[0].length > 0 ? "TABL" : "DATA"
            });
          } else {
            this.setState({
              tableStatus: "NETW"
            });
          }
        });
      }
    );
  };

  renderTevekenysegTipusOptions = () => {
    let options = [];
    if (this.state.helyszin.kozpont) {
      this.state.kozpontienums.forEach(e =>
        options.push(
          <option key={e.name} value={e.name}>
            {e.caption}
          </option>
        )
      );
    } else {
      this.state.enums.forEach(e =>
        options.push(
          <option key={e.name} value={e.name}>
            {e.caption}
          </option>
        )
      );
    }
    return options;
  };

  handleEsetTipusSelectChange = e => {
    this.setState({
      esettipusid: e.target.value
    });
  };

  renderEsetTipusOptions = () => {
    let options = [];
    this.state.esettipusok.forEach(e =>
      options.push(
        <option key={e.id} value={e.id}>
          {e.nev}
        </option>
      )
    );
    return options;
  };

  renderPartnerAdatok = () => {
    let titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };

    return (
      <Fragment>
        <Label>
          <h5>Partner(ek) hozzáadása:</h5>
          <br />
        </Label>
        {this.renderPartnerList()}
        <div>
          <Button
            className="pull-left table-new-button"
            color="success"
            onClick={() => {
              this.addPartnerAdatRow();
            }}
          >
            Új hozzáadása
          </Button>
          <br />
        </div>
      </Fragment>
    );
  };

  updateTable = () => {
    this.getTevekenysegList();
  };

  toggleNezet = () => {
    this.setState(prevState => ({
      modalNezet: !prevState.modalNezet
    }));
  };

  toggleTevekenyseg = () => {
    this.setState(prevState => ({
      modalTevekenyseg: !prevState.modalTevekenyseg
    }));
  };

  toggleEditors = () => {
    this.setState(prevState => ({
      editorsOpen: !prevState.editorsOpen
    }));
  }

  toggleTevekenysegTorles = () => {
    this.setState(prevState => ({
      modalTevekenysegTorles: !prevState.modalTevekenysegTorles
    }));
  };

  checkTipus = () => {
    if (!this.state.tipus) {
      this.props.globals.addError("Típus választása kötelező!");
      return false;
    }
    return true;
  };

  deleteTevekenyseg = () => {
    this.toggleTevekenysegTorles();
    Service.deleteTevekenyseg(this._currentId, err => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess("Tevékenység törölve!");
      }
    });
  };

  listImages = (callback) => {
    Service.listEditorImages((err, res) => {
      if (!err) {
        callback(typeof res === "object" ? res[0] : []);
      }
    });
  }

  addImage = async (file) => {
    const { url, funkcioid } = await parseEditorImage((cb) => Service.uploadEditorImage(file, this.state.currentId || undefined, cb));
    this.setState(prev => ({ deletedImages: prev.deletedImages.filter(x => x !== url) }));
    this.setState({ currentId: funkcioid })
    return url;
  }

  handleFormCancelClick = () => {
    if (this.state.formType === "FEL" && this.state.currentId) {
      Service.deleteEditorImages(this.state.currentId, () => {});
    }
    this.setState({ currentId: null, deletedImages: [] });
  }

  removeImage = (node) => {
    const src = node.attrs.src;
    if(src?.startsWith('data:')) return;

    this.setState(prev => ({ deletedImages: [...prev.deletedImages, src] }));
  }

  onChangeLeiras = (value) => {
    const v = value;
    this.setState({ leiras: value  });
  };
  
  onChangeLeirasAngol = (value) => {
    this.setState({ leirasAngol: value });
  }

  renderLeirasAngolEditor = () => {
    return (
      <EditorTevekenyseg
        onChange={this.onChangeLeirasAngol}
        field={this.state.leirasAngol}
        fontId={"EditorLeirasAngol"}
        // listImages={this.listImages}
        // addImage={this.addImage}
      />
    );
  }

  renderEditors = () => {
    return (
      <Modal isOpen={this.state.editorsOpen} toggle={() => this.toggleEditors()} backdrop="static" size="xl">
        <ModalHeader>Leírások</ModalHeader>
        <ModalBody>
          {/* {Editoranyad(this.onChangeLeiras, this.state.leiras, "leiras")} */}
          {renderLeirasEditor(this.onChangeLeiras, this.state.leiras, "EditorLeiras")}
          {/* {this.state.angolNyelv == true ?
            <div>
              <Label for="leirasangol">Leírás (angol): *</Label>
              {this.renderLeirasAngolEditor()}
            </div>
            : <div />} */}
        </ModalBody>
        <ModalFooter>
          <Button className="secondary" onClick={() => this.toggleEditors()}>OK</Button>
        </ModalFooter>
      </Modal>
    );
  }

  renderAdatok = (id) => {
    return (
      <div>
        <div>
          <b>Helyszín neve: </b>
          {this.state.helyszin.nev}
          <br />
          <b>Tevékenység típusa: </b>
          {this.state.tipus.caption}
          {this.state.esettipusnev && this.state.esettipusnev != "" ? (
            <div>
              <b>Ügyfélszolgálati eset típusa: </b>
              {this.state.esettipusnev}
            </div>
          ) : ('')}
          <div>
            {this.state.tipus.name === "PAR" ? (
              <div>
                <div>
                  <b>Partnerek:</b>
                </div>

                {this.state.partnerAdatok.map((tevekenyseg, index) => {
                  return (
                    <div key={index.toString()}>
                      <br />
                      <b>Partner neve:</b>
                      {tevekenyseg.partnerNeve}
                      <br />
                      <b>Leírás: </b>
                      {ReactHtmlParser(tevekenyseg.leiras)}
                      <br />
                      {this.state.angolNyelv == true ?
                        <div>
                          <b>Leírás (angol): </b>
                          {ReactHtmlParser(tevekenyseg.leirasangol)}
                          <br />
                        </div>
                        : <div />
                      }
                      <br />
                      <b>Partner logó:</b>
                      <br />
                      <div>
                        {tevekenyseg.objects !== null
                          ? tevekenyseg.objects.map((logo, logoIdx) => {
                            return (
                              <div
                                className="col-md-3 justify-content-md-center"
                                key={logoIdx.toString()}
                              >
                                <ImageCard
                                  poster
                                  style={{ width: "200px", height: "200px" }}
                                  key={logoIdx.toString()}
                                  mime={logo.mime}
                                  title={logo.docname}
                                  content={logo.content}
                                  src={logo.src}
                                  hasButton={false}
                                />
                              </div>
                            );
                          })
                          : ""}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
                this.state.partnerAdatok && this.state.partnerAdatok.map((tevekenyseg, index) => {
                  if (tevekenyseg) {
                    return (
                      <div key={toString(index)}>
                        <b>Leírás: </b>
                        {ReactHtmlParser(tevekenyseg.leiras)}
                        <br />
                        {this.state.angolNyelv == true ?
                          <div>
                            <b>Leírás (angol): </b>
                            {ReactHtmlParser(tevekenyseg.leirasangol)}
                            <br />
                          </div>
                          : <div />
                        }
                      </div>
                    );
                  }
                })
              )}
          </div>
        </div>
      </div>
    );
  };

  onDropLogo = (acceptedfiles, idx) => {
    acceptedfiles.forEach(file2 => {
      const reader = new FileReader();
      let file = [];
      reader.onload = () => {
        const fileAsBinaryString = reader.result;

        if (
          Array.isArray(this.state.partnerAdatok.objects) &&
          this.state.partnerAdatok.objects.length > 0
        ) {
          this.props.globals.addError("Csak egy logó tölthető fel!");
        } else {
          file.push({
            content: btoa(fileAsBinaryString),
            uploadDate: new Date(),
            docname: file2.name,
            type: "LOGO",
            preview: file2.preview,
            logo: false,
            mime: file2.type || "application/octet-stream",
            new: true,
            length: file2.size
            // name: "partnerLogo" + index,
            // id: "partnerLogo" + Lib.Browser.uuidv4()
          });
          let partnerAdatok = JSON.parse(
            JSON.stringify(this.state.partnerAdatok)
          );
          partnerAdatok[idx].objects = file;
          this.setState({ partnerAdatok: partnerAdatok });
        }
      };
      reader.readAsBinaryString(file2);
    });
  };

  renderTable = () => {
    const columns = [
      {
        dataField: "tipusnev",
        text: "Tevékenység típusa",
        filter: textFilter({
          delay: 400,
          placeholder: "Keresés..."
        }),
        sort: true
      },
      {
        dataField: "id",
        text: "Műveletek",
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.tevekenysegJson}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  };

  renderForm = () => {
    return (
      <Fragment>
        <RFField
          type="select"
          name="tipus"
          label="Típus: *"
          value={this.state.tipus.name}
          onChange={this.handleTevekenysegTipusSelectChange}
          disabled={this.state.formType === "MOD"}
          required
          defaultSelect={<option value="">Válassz típust...</option>}
          selectOptions={this.renderTevekenysegTipusOptions()}
        />
        {["UGY", "MED", "TER"].includes(this.state.tipus) || ["UGY", "MED", "TER"].includes(this.state.tipus.name) ? (
          <RFField
            type="select"
            name="formEsetTipus"
            label="Ügyfélszolgálati eset típus:"
            value={this.state.esettipusid}
            onChange={this.handleEsetTipusSelectChange}
            defaultSelect={<option value="">Válassz eset típust...</option>}
            selectOptions={this.renderEsetTipusOptions()}
          />
        ) : ('')}
        <>
          {this.state.tipus === "PAR" || this.state.tipus.name === "PAR" ? (
            this.renderPartnerAdatok()
          ) : (
            <>
              <label>Leírás:</label>
              <EditorTevekenyseg
                onChange={this.onChangeLeiras}
                field={this.state.leiras}
                fontId={"EditorLeiras"}
                addImage={this.addImage}
                removeImage={this.removeImage}
              />
              {this.state.angolNyelv && 
                <>
                  <label className="mt-1">Leírás (angol):</label>
                  <EditorTevekenyseg
                    onChange={this.onChangeLeirasAngol}
                    field={this.state.leirasAngol}
                    fontId={"EditorLeirasAngol"}
                    addImage={this.addImage}
                    removeImage={this.removeImage}
                  />
                </>
              }
            </>
          )}
        </>
        <>
          <div id="partnerek" />
        </>
      </Fragment>
    );
  };

  submitForm = () => {
    const { formType, leiras, leirasAngol } = this.state;
    if (formType === "FEL") {
      let tevekenysegAdd = [];
      if (this.checkTipus()) {
        if (this.state.tipus === "PAR") {
          tevekenysegAdd = this.state.partnerAdatok;
          tevekenysegAdd.tipus = JSON.parse(JSON.stringify(this.state.tipus));
        } else {
          let object = {
            tipus: this.state.tipus,
            leiras: leiras,
            esetTipusId: this.state.esettipusid
          };
          if (this.state.angolNyelv == true) {
            object = {
              ...object,
              leirasangol: leirasAngol
            }
          }
          tevekenysegAdd.push(object);
        }
        Service.addTevekenyseg(tevekenysegAdd, this.state.helyszinid, err => {
          if (!err) {
            this.toggleTevekenyseg();
            this.updateTable();
            this.props.globals.addSuccess("Tevékenység hozzáadva!");
          }
        });
      }
    }
    if (formType === "MOD") {
      let tevekenysegModosit = [];
      if (
        (this.state.tipus.name && this.state.tipus.name === "PAR") ||
        this.state.tipus === "PAR"
      ) {
        tevekenysegModosit = this.state.partnerAdatok;
        tevekenysegModosit = tevekenysegModosit.map((element, idx) => {
          element.tipus = this.state.tipus.name
            ? this.state.tipus.name
            : this.state.tipus;
          return element;
        });
      } else {
        tevekenysegModosit = this.state.partnerAdatok;
        tevekenysegModosit = [];
        let object = {
          helyszinid: this.state.helyszinid,
          id: this.state.tevekenysegid,
          leiras: leiras,
          esetTipusId: this.state.esettipusid,
          tipus: this.state.tipus.name
            ? this.state.tipus.name
            : this.state.tipus
        };
        if (this.state.angolNyelv == true) {
          object = {
            ...object,
            leirasangol: leirasAngol
          };
        }
        tevekenysegModosit.push(object);

        tevekenysegModosit = tevekenysegModosit.map(element => {
          element.tipus = this.state.tipus.name
            ? this.state.tipus.name
            : this.state.tipus;

          return element;
        });
      }
      Service.modifyTevekenyseg(
        tevekenysegModosit,
        this.state.helyszinid,
        err => {
          if (!err) {
            this.toggleTevekenyseg();
            this.updateTable();
            this.props.globals.addSuccess("Tevékenység módosítva!");
          }
        }
      );
    }
    this.setState({ currentId: null });

    if(this.state.currentId) {
      for(const src of this.state.deletedImages) {
        Service.deleteEditorImage(this.state.currentId, src.split('/').at(-1), () => {});
      }
    }
  };

  render() {
    const { tevekenysegModosit } = this.state;

    return (
      <Fragment>
        <div className="row">
          <div className="col-md-3">{this.helyszinValaszto()}</div>
        </div>
        <div className="row">
          {(this.state.tableStatus === "DATA" ||
            this.state.tableStatus === "TABL") && (
              <div className="col-sm-12">
                <Button
                  className="pull-left table-new-button"
                  color="primary"
                  disabled={this.state.helyszinid === ""}
                  onClick={() => {
                    if (this.state.angolNyelv == true) {
                      this.setState({ leirasAngol: '' });
                    }
                    this.setState(
                      {
                        tipus: "",
                        formType: "FEL",
                        leiras: '',
                        esettipusid: ""
                        // objects: []
                        // partnerAdatok: [
                        //   {
                        //     //     helyszinid: this.state.helyszinid,
                        //     //     tipus: "PAR",
                        //     //     partnernev: "",
                        //     objects: []
                        //     //     leiras: ""
                        //   }
                        // ]
                      },
                      () => {
                        this.addPartnerAdatRow();
                        this.toggleTevekenyseg();
                      }
                    );
                  }}
                >
                  Új tevékenység hozzáadása
              </Button>
              </div>
            )}
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.tableStatus === "TABL" ? (
              this.renderTable()
            ) : this.state.tableStatus === "NETW" ? (
              <NetworkEmptyState hasImage submitClick={this.updateTable} />
            ) : this.state.tableStatus === "DATA" ? (
              <DataEmptyState hasImage submitClick={this.updateTable} />
            ) : this.state.tableStatus === "LOAD" ? (
              <Loader />
            ) : (
                      <div />
                    )}
          </div>
        </div>

        <div>
          {/* <Modal
            isOpen={this.state.modalTevekenyseg}
            toggle={this.toggleTevekenyseg}
            className={this.props.className}
            backdrop={"static"}
          > */}
            <RFForm
              tagProps={{ isOpen: this.state.modalTevekenyseg, toggle: this.toggleTevekenyseg, backdrop: 'static' }}
              modalInsert
              onSubmit={this.submitForm}
              title={this.renderFormTitle()}
              footer={
                <>
                  <Button color="primary" type="submit">Mentés</Button>
                  <Button
                    type="button"
                    color="secondary"
                    onClick={() => {
                      this.handleFormCancelClick();
                      this.toggleTevekenyseg();
                      this.setState({
                        tipus: "",
                        formType: "FEL",
                        partnerAdatok: [],
                        currentId: null,
                      });
                    }}
                  >
                    Mégsem
                  </Button>
                </>
              }
            >
              {this.renderForm()}
              {this.renderEditors()}
            </RFForm>
          {/* </Modal> */}
        </div>
        <div>
          <Modal
            isOpen={this.state.modalTevekenysegTorles}
            toggle={this.toggleTevekenysegTorles}
            className={this.props.className}
            backdrop="static"
          >
            <ModalHeader>Törlés</ModalHeader>
            <ModalBody>
              Biztosan törölni szeretnéd ezt a tevékenységet?
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.deleteTevekenyseg}>
                OK
              </Button>
              <Button
                type="button"
                color="secondary"
                onClick={this.toggleTevekenysegTorles}
              >
                Mégsem
              </Button>
            </ModalFooter>
          </Modal>
          <Modal
            isOpen={this.state.modalNezet}
            toggle={this.toggleNezet}
            className={this.props.className}
            backdrop="static"
          >
            <ModalHeader>Tevékenység információ</ModalHeader>
            <ModalBody>{this.renderAdatok()}</ModalBody>
            <ModalFooter>
              <Button type="button" color="primary" onClick={this.toggleNezet}>
                Vissza
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </Fragment>
    );
  }
}

export default TevekenysegContent;
